import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { useAsync, Spinner } from '@wix/cli-ui-kit';
import { Trans } from '@wix/cli-i18n';
import { useProjectModel } from '../../model.js';
import { assertBuildOutputExists } from '../../files/assert-build-output-exists.js';
import { Release } from './Release.js';
import type { ReleaseVersionType } from './types.js';

export interface ReleaseCommandProps {
  baseUrl?: string;
  siteIdOverride?: string;
  preEnteredComment?: string;
  preSelectedVersionType?: ReleaseVersionType;
  onReleaseDraftCreated?: (version: string) => void;
}

export const ReleaseCommand: FC<ReleaseCommandProps> = (props) => {
  const {
    model: { projectFolder },
  } = useProjectModel();

  const { status } = useAsync(async () => {
    await assertBuildOutputExists(projectFolder);
  }, []);

  return match(status, {
    Error: () => null,
    Loading: () => (
      <Spinner text={<Trans i18nKey="release_command.loading_app_details" />} />
    ),
    Success: () => <Release {...props} />,
  });
};
